import api from './api';
import { REVIEW_API } from '../utils/constants';

// Create review - type ke saath
export const createReview = async (reviewData) => {
    const response = await api.post(
        `${REVIEW_API}/create`, reviewData);
    return response.data;
};

// Update review
export const updateReview = async (id, reviewData) => {
    const response = await api.put(
        `${REVIEW_API}/update/${id}`, reviewData);
    return response.data;
};

// ===== TYPE KE HISAAB SE =====

// Poojari ko mile reviews - user ne diye
export const getReviewsForPoojari = async (poojariId) => {
    const response = await api.get(
        `${REVIEW_API}/for-poojari/${poojariId}`);
    return response.data;
};

// User ko mile reviews - poojari ne diye
export const getReviewsForUser = async (userId) => {
    const response = await api.get(
        `${REVIEW_API}/for-user/${userId}`);
    return response.data;
};

// User ki average rating
export const getUserRating = async (userId) => {
    const response = await api.get(
        `${REVIEW_API}/user/${userId}/rating`);
    return response.data;
};

// Is booking pe review ho chuka hai?
export const hasReviewed = async (bookingId, reviewType) => {
    const response = await api.get(
        `${REVIEW_API}/has-reviewed/${bookingId}`
        + `?reviewType=${reviewType}`);
    return response.data;
};

// ===== BAAKI =====

// Get review by booking ID
export const getReviewByBooking = async (bookingId) => {
    const response = await api.get(
        `${REVIEW_API}/booking/${bookingId}`);
    return response.data;
};

// Get reviews by poojari - sab
export const getReviewsByPoojari = async (poojariId) => {
    const response = await api.get(
        `${REVIEW_API}/poojari/${poojariId}`);
    return response.data;
};

// Get reviews by user - sab
export const getReviewsByUser = async (userId) => {
    const response = await api.get(
        `${REVIEW_API}/user/${userId}`);
    return response.data;
};

// Get rating summary
export const getRatingSummary = async (poojariId) => {
    const response = await api.get(
        `${REVIEW_API}/poojari/${poojariId}/summary`);
    return response.data;
};

// Delete review
export const deleteReview = async (id) => {
    const response = await api.delete(
        `${REVIEW_API}/delete/${id}`);
    return response.data;
};